import * as loaders from "@lts/loaders/legacy/legacy-objFileLoader";
export { loaders };
export default loaders;
